<div class="col-sm-12">
  <h2>Status of Competition for Video Services in Michigan</h2>
</div>
<div class="container well col-sm-12" *ngIf="!completionPage">
  <div class="row">
    <div class="col-sm-12">
      <h3>MPSC Annual Franchise Entities Survey – 2026</h3>
      <p>
        This survey is for all franchise entities (municipalities) in Michigan.
        “Franchise Entity” means the local unit of government (city, village, or
        township) in which a provider offers video services.
      </p>
      <p>
        Please
        <u>do not</u> provide any information that may be deemed confidential.
        Please submit your response to this survey by
        <strong>
          November 9, 2026, and submit only one (1) survey response per
          franchise entity.</strong
        >
        This survey will no longer be available after November 9, 2026.
      </p>
      <p>
        The MPSC values your input and comments. Should you have any questions
        regarding this information request, please e-mail Erin West at
        <a href="mailto:WestE1@michigan.gov">WestE1@michigan.gov</a>.
      </p>
      <hr />
    </div>
  </div>

  <h3>Contact Information</h3>

  <div class="row col-sm-12">
    <div class="form-group col-sm-4">
      <label for="franchiseEntity" class="control-label required"
        >Franchise Entity (Municipality)</label
      >
      <input
        type="text"
        class="form-control"
        trim="blur"
        id="franchiseEntity"
        [formControl]="franchiseForm.controls['franchiseEntity']"
        [(ngModel)]="franchiseData.franchiseEntity"
        placeholder="Enter Franchise Entity"
        required
        name="franchiseEntity"
      />
      <div
        *ngIf="
          (franchiseForm?.controls['franchiseEntity']?.errors?.required ||
            franchiseForm?.controls['franchiseEntity']?.errors?.isValid) &&
          franchiseForm?.controls['franchiseEntity']?.touched
        "
        class="error-msg"
      >
        Franchise Entity is Required!
      </div>
    </div>
    <div class="form-group col-sm-4">
      <label for="address1" class="control-label required">Address</label>
      <input
        type="text"
        class="form-control"
        trim="blur"
        id="address1"
        [formControl]="franchiseForm.controls['address1']"
        [(ngModel)]="franchiseData.address1"
        placeholder="Enter Address"
        required
        name="Address1"
      />
      <div
        *ngIf="
          (franchiseForm?.controls['address1']?.errors?.required ||
            franchiseForm?.controls['address1']?.errors?.isValid) &&
          franchiseForm?.controls['address1']?.touched
        "
        class="error-msg"
      >
        Address is Required!
      </div>
    </div>
    <div class="form-group col-sm-4">
      <label for="address2" class="control-label">Address 2</label>
      <input
        type="text"
        class="form-control"
        id="address2"
        trim="blur"
        [formControl]="franchiseForm.controls['address2']"
        [(ngModel)]="franchiseData.address2"
        placeholder="Enter Address 2"
        name="address2"
      />
    </div>
  </div>
  <div class="row col-sm-12">
    <div class="form-group col-sm-4">
      <label for="city" class="control-label required"
        >City/Township/Village
      </label>
      <input
        type="text"
        class="form-control"
        id="city"
        trim="blur"
        [formControl]="franchiseForm.controls['city']"
        [(ngModel)]="franchiseData.city"
        placeholder="Enter City"
        required
        name="city"
      />
      <div
        *ngIf="
          (franchiseForm?.controls['city']?.errors?.required ||
            franchiseForm?.controls['city']?.errors?.isValid) &&
          franchiseForm?.controls['city']?.touched
        "
        class="error-msg"
      >
        City/Township/Village is Required!
      </div>
    </div>
    <div class="form-group col-sm-4">
      <label for="county" class="control-label required">County </label>
      <input
        type="text"
        class="form-control"
        id="county"
        trim="blur"
        [formControl]="franchiseForm.controls['county']"
        [(ngModel)]="franchiseData.county"
        placeholder="Enter County"
        required
        name="county"
      />
      <div
        *ngIf="
          (franchiseForm?.controls['county']?.errors?.required ||
            franchiseForm?.controls['county']?.errors?.isValid) &&
          franchiseForm?.controls['county']?.touched
        "
        class="error-msg"
      >
        County is Required!
      </div>
    </div>
    <div class="form-group col-sm-4">
      <label for="state" class="control-label required">State </label>
      <input
        name="state"
        id="state"
        class="form-control"
        disabled
        value="Michigan"
        [formControl]="franchiseForm.controls['state']"
        [(ngModel)]="franchiseData.state"
        required
      />
    </div>
  </div>
  <div class="row col-sm-12">
    <div class="form-group col-sm-4">
      <label for="zip" class="control-label required">Zip </label>
      <input
        type="text"
        class="form-control"
        id="zip"
        [formControl]="franchiseForm.controls['zip']"
        [(ngModel)]="franchiseData.zip"
        placeholder="12345 or 12345-6789"
        required
        name="zip"
      />
      <div
        *ngIf="
          (franchiseForm?.controls['zip']?.errors?.required ||
            franchiseForm?.controls['zip']?.errors?.isValid) &&
          franchiseForm?.controls['zip']?.touched
        "
        class="error-msg"
      >
        Zip is Required!
      </div>
      <div
        *ngIf="
          franchiseData.zip != 'undefined' &&
          franchiseData.zip != null &&
          franchiseData.zip != '' &&
          franchiseForm?.controls['zip']?.errors?.invalidZip &&
          franchiseForm?.controls['zip']?.touched
        "
        class="error-msg"
      >
        Please enter a valid zip!
      </div>
    </div>
    <div class="form-group col-sm-4">
      <label for="contactPerson" class="control-label required"
        >Contact Person
      </label>
      <input
        type="text"
        class="form-control"
        id="contactPerson"
        trim="blur"
        [formControl]="franchiseForm.controls['contactPerson']"
        [(ngModel)]="franchiseData.contactPerson"
        placeholder="Enter Contact Person"
        required
        name="contactPerson"
      />
      <div
        *ngIf="
          (franchiseForm?.controls['contactPerson']?.errors?.required ||
            franchiseForm?.controls['contactPerson']?.errors?.isValid) &&
          franchiseForm?.controls['contactPerson']?.touched
        "
        class="error-msg"
      >
        Contact Person is Required!
      </div>
    </div>
    <div class="form-group col-sm-4">
      <label for="phoneNumber" class="control-label required"
        >Direct Phone
      </label>
      <input
        type="text"
        [mask]="mask"
        class="form-control"
        id="phoneNumber"
        [formControl]="franchiseForm.controls['phoneNumber']"
        [(ngModel)]="franchiseData.phoneNumber"
        placeholder="Enter Direct Phone Number"
        required
        name="phoneNumber"
      />
      <div
        *ngIf="
          (franchiseForm?.controls['phoneNumber']?.errors?.required ||
            franchiseForm?.controls['phoneNumber']?.errors?.isValid) &&
          franchiseForm?.controls['phoneNumber']?.touched
        "
        class="error-msg"
      >
        Direct Phone is Required!
      </div>
      <div
        *ngIf="
          franchiseData.phoneNumber != 'undefined' &&
          franchiseData.phoneNumber != null &&
          franchiseData.phoneNumber != '' &&
          franchiseForm?.controls['phoneNumber']?.errors?.invalidPhone &&
          franchiseForm?.controls['phoneNumber']?.touched
        "
        class="error-msg"
      >
        Please enter a valid Direct Phone!
      </div>
    </div>
  </div>
  <div class="row col-sm-12">
    <div class="form-group col-sm-4">
      <label for="emailId" class="control-label required">Direct Email </label>
      <input
        type="email"
        class="form-control"
        id="emailId"
        [formControl]="franchiseForm.controls['emailId']"
        [(ngModel)]="franchiseData.emailId"
        placeholder="Enter Direct Email "
        required
        name="emailId"
      />
      <div
        *ngIf="
          franchiseForm?.controls['emailId']?.errors?.required &&
          franchiseForm?.controls['emailId']?.touched
        "
        class="error-msg ml-3"
      >
        Direct Email is Required!
      </div>
      <div
        *ngIf="
          franchiseData.emailId != 'undefined' &&
          franchiseData.emailId != null &&
          franchiseData.emailId != '' &&
          franchiseForm?.controls['emailId']?.errors?.email &&
          franchiseForm?.controls['emailId']?.touched
        "
        class="error-msg"
      >
        Please enter a valid Direct Email Address!
      </div>
    </div>
  </div>

  <div class="form-group col-sm-12">
    <fieldset id="question1Group">
      <legend class="form-check-label legend-hidden">1.</legend>
      <label id="question1Label" class="form-check-label required">
        1. In {{ today | date: "yyyy" }}, how many
        <u>total</u> video/cable providers have franchise agreements to service
        your community?</label
      >

      <div *ngFor="let option of radioBtnOptions; let i = index" class="ml-3">
        <label for="question1{{ i }}">
          <input
            type="radio"
            id="question1{{ i }}"
            name="question1Group"
            [(ngModel)]="franchiseData.question1"
            [formControl]="franchiseForm.controls['question1']"
            [value]="option.value"
          />
          {{ option.display }}
        </label>
      </div>
      <div
        *ngIf="
          franchiseForm?.controls['question1']?.errors?.required &&
          franchiseForm?.controls['question1']?.touched
        "
        class="error-msg ml-3"
      >
        This field is Required!
      </div>
    </fieldset>
  </div>

  <div class="form-group col-sm-12">
    <label class="form-check-label required">
      2. Please indicate the video/cable providers who are currently providing
      video/cable service to your community (Select as many that apply).
    </label>
    <div class="form-check col-sm-12 ml-3">
      <input
        type="hidden"
        name="comcastToggle"
        [(ngModel)]="franchiseData.comcast"
      />
      <label>
        <input
          type="checkbox"
          class="form-check-input"
          [formControl]="franchiseForm.controls['question2Comcast']"
          [checked]="franchiseData.question2Comcast === yesNoOptions[0].value"
          (change)="
            $event.target.checked
              ? (franchiseData.question2Comcast = yesNoOptions[0].value)
              : (franchiseData.question2Comcast = yesNoOptions[1].value)
          "
        />
        Comcast
      </label>
    </div>

    <div class="ml-3">
      <div class="form-check col-sm-12">
        <input
          type="hidden"
          name="question2CharterToggle"
          [(ngModel)]="franchiseData.question2Charter"
        />
        <label>
          <input
            type="checkbox"
            class="form-check-input"
            [formControl]="franchiseForm.controls['question2Charter']"
            [checked]="franchiseData.question2Charter === yesNoOptions[0].value"
            (change)="
              $event.target.checked
                ? (franchiseData.question2Charter = yesNoOptions[0].value)
                : (franchiseData.question2Charter = yesNoOptions[1].value)
            "
          />
          Charter Communications
        </label>
      </div>
      <div class="form-check col-sm-12">
        <input
          type="hidden"
          name="question2AttToggle"
          [(ngModel)]="franchiseData.question2Att"
        />
        <label>
          <input
            type="checkbox"
            class="form-check-input"
            [formControl]="franchiseForm.controls['question2Att']"
            [checked]="franchiseData.question2Att === yesNoOptions[0].value"
            (change)="
              $event.target.checked
                ? (franchiseData.question2Att = yesNoOptions[0].value)
                : (franchiseData.question2Att = yesNoOptions[1].value)
            "
          />
          AT&amp;T U-Verse
        </label>
      </div>
      <div class="form-check col-sm-12">
        <input
          type="hidden"
          aria-label="question2OtherToggle"
          name="question2OtherToggle"
          [(ngModel)]="franchiseData.question2Other"
        />
        <label>
          <input
            type="checkbox"
            class="form-check-input"
            [formControl]="franchiseForm.controls['question2Other']"
            [checked]="franchiseData.question2Other === yesNoOptions[0].value"
            (change)="checkQuestion2($event.target.checked)"
          />
          Other (Please write in box below)
        </label>
      </div>
      <div class="form-group col-sm-12 ml-3">
        <textarea
          class="form-control"
          [disabled]="franchiseData.question2Other !== 'Yes'"
          trim="blur"
          name="question2Comment"
          aria-label="question2Comment"
          [(ngModel)]="franchiseData.question2Comment"
          id="question2Comment"
        >
        </textarea>
        <div
          *ngIf="
            franchiseData.question2Other === 'Yes' &&
            (franchiseData.question2Comment === '' ||
              franchiseData.question2Comment === 'undefined' ||
              franchiseData.question2Comment === null)
          "
          class="error-msg ml-3"
        >
          This field is Required when other is checked!
        </div>
      </div>
    </div>
    <div
      *ngIf="
        franchiseData.question2Other === 'No' &&
        franchiseData.question2Comcast === 'No' &&
        franchiseData.question2Charter === 'No' &&
        franchiseData.question2Att === 'No' &&
        (franchiseForm?.controls['question2Other']?.touched ||
          franchiseForm?.controls['question2Comcast']?.touched ||
          franchiseForm?.controls['question2Charter']?.touched ||
          franchiseForm?.controls['question2Att']?.touched)
      "
      class="error-msg ml-3"
    >
      Atleast one option should be selected!
    </div>
  </div>

  <div class="form-group col-sm-12">
    <fieldset id="question3Group">
      <legend class="form-check-label legend-hidden">3.</legend>
      <label id="question3Label" class="form-check-label required">
        3.
        <i>Since <u>January 1, {{ today | date: "yyyy" }}</u>,</i> how many new video/cable (not
        satellite) providers have filed for a Uniform Video Services Local
        Franchise Agreement in your area?
      </label>
      <div *ngFor="let option of radioBtnOptions; let i = index" class="ml-3">
        <label for="question3{{ i }}">
          <input
            type="radio"
            id="question3{{ i }}"
            [formControl]="franchiseForm.controls['question3']"
            name="question3Group"
            [(ngModel)]="franchiseData.question3"
            [value]="option.value"
          />
          {{ option.display }}
        </label>
      </div>
      <div
        *ngIf="
          franchiseForm?.controls['question3']?.errors?.required &&
          franchiseForm?.controls['question3']?.touched
        "
        class="error-msg ml-3"
      >
        This field is Required!
      </div>
    </fieldset>
  </div>
  <div class="form-group col-sm-12">
    <fieldset id="question4Group">
      <legend class="form-check-label legend-hidden">.</legend>
      <label id="question4Label" class="form-check-label required">
        4.
        <i>Prior</i> to 2006 PA 480 taking effect on <u>January 1, 2007</u>, how
        many video/cable (not satellite) providers were offering service in your
        area?
      </label>
      <div *ngFor="let option of radioBtn1Options; let i = index" class="ml-3">
        <label for="question4{{ i }}">
          <input
            type="radio"
            id="question4{{ i }}"
            [formControl]="franchiseForm.controls['question4']"
            name="question4Group"
            [(ngModel)]="franchiseData.question4"
            [value]="option.value"
          />
          {{ option.display }}
        </label>
      </div>
      <div
        *ngIf="
          franchiseForm?.controls['question4']?.errors?.required &&
          franchiseForm?.controls['question4']?.touched
        "
        class="error-msg ml-3"
      >
        This field is Required!
      </div>
    </fieldset>
  </div>

  <div class="form-group col-sm-12">
    <label class="form-check-label required">
      5. Please indicate the satellite providers that you are aware of who are
      currently offering video/cable service in your community (Select as many
      that apply).
    </label>
    <div class="ml-3">
      <div class="form-check" class="ml-3">
        <input
          type="hidden"
          name="question5DishToggle"
          [(ngModel)]="franchiseData.question5Dish"
        />
        <label>
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="franchiseData.question5Dish === yesNoOptions[0].value"
            (change)="
              $event.target.checked
                ? (franchiseData.question5Dish = yesNoOptions[0].value)
                : (franchiseData.question5Dish = yesNoOptions[1].value)
            "
          />
          Dish Network
        </label>
      </div>

      <div class="form-check" class="ml-3">
        <input
          type="hidden"
          name="question5DirectToggle"
          [(ngModel)]="franchiseData.question5Direct"
        />
        <label>
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="franchiseData.question5Direct === yesNoOptions[0].value"
            (change)="
              $event.target.checked
                ? (franchiseData.question5Direct = yesNoOptions[0].value)
                : (franchiseData.question5Direct = yesNoOptions[1].value)
            "
          />
          Direct TV
        </label>
      </div>
      <div class="form-check" class="ml-3">
        <input
          type="hidden"
          name="question5OtherToggle"
          [(ngModel)]="franchiseData.question5Other"
        />
        <label>
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="franchiseData.question5Other === yesNoOptions[0].value"
            (change)="checkQuestion5($event.target.checked)"
          />
          Other (Please write in box below)
        </label>
      </div>
      <div class="form-group col-sm-12" class="ml-3">
        <textarea
          class="form-control"
          [disabled]="franchiseData.question5Other !== 'Yes'"
          trim="blur"
          name="question5Comment"
          aria-label="question5Comment"
          [(ngModel)]="franchiseData.question5Comment"
          id="question5Comment"
        >
        </textarea>
        <div
          *ngIf="
            franchiseData.question5Other === 'Yes' &&
            (franchiseData.question5Comment === '' ||
              franchiseData.question5Comment === 'undefined' ||
              franchiseData.question5Comment === null)
          "
          class="error-msg ml-3"
        >
          This field is Required when other is checked!
        </div>
      </div>
    </div>
    <div
      *ngIf="
        franchiseData.question5Dish === 'No' &&
        franchiseData.question5Direct === 'No' &&
        franchiseData.question5Other === 'No' &&
        (franchiseForm?.controls['question5Dish']?.touched ||
          franchiseForm?.controls['question5Direct']?.touched ||
          franchiseForm?.controls['question5Other']?.touched)
      "
      class="error-msg ml-3"
    >
      Atleast one option should be selected!
    </div>
  </div>
  <div class="form-group col-sm-12">
    <fieldset id="question3Group">
      <legend class="form-check-label legend-hidden">6.</legend>
      <label id="question6Label" class="form-check-label required">
        6. Are you aware of the video/cable complaint process, Public Act 4 of
        2009?
      </label>

      <div class="form-check ml-3">
        <input
          type="radio"
          class="form-check-input"
          [formControl]="franchiseForm.controls['question6']"
          name="question6Group"
          [(ngModel)]="franchiseData.question6"
          id="question6Yes"
          value="Yes"
        />
        <label for="question6Yes"> Yes </label>
      </div>
      <div class="form-check ml-3">
        <input
          type="radio"
          class="form-check-input"
          [formControl]="franchiseForm.controls['question6']"
          name="question6Group"
          id="question6No"
          [(ngModel)]="franchiseData.question6"
          value="No"
        />
        <label for="question6No">
          No - If you answered no, please review MPSC's
          <a target="_blank"
            href="https://www.michigan.gov/mpsc/regulatory/telecommunications/video-cable"
          >
            <strong> Video/Cable Regulatory Information.</strong>
          </a>
        </label>
      </div>
      <div
        *ngIf="
          franchiseForm?.controls['question6']?.errors?.required &&
          franchiseForm?.controls['question6']?.touched
        "
        class="error-msg ml-3"
      >
        This field is Required!
      </div>
    </fieldset>
  </div>

  <div class="form-group col-sm-12">
    <fieldset id="question7Group">
      <legend class="form-check-label legend-hidden">7.</legend>
      <label id="question7Label" class="form-check-label required">
        7. Is your franchise entity still receiving video/cable complaints from
        customers?
      </label>
      <div *ngFor="let option of yesNoOptions; let i = index" class="ml-3">
        <label for="question7{{ i }}">
          <input
            type="radio"
            id="question7{{ i }}"
            [formControl]="franchiseForm.controls['question7']"
            (change)="resetQuestion7()"
            name="question7Group"
            [(ngModel)]="franchiseData.question7"
            [value]="option.value"
          />
          {{ option.display }}
        </label>
      </div>
      <div
        *ngIf="
          franchiseForm?.controls['question7']?.errors?.required &&
          franchiseForm?.controls['question7']?.touched
        "
        class="error-msg ml-3"
      >
        This field is Required!
      </div>
    </fieldset>
    <div *ngIf="franchiseData.question7 == 'Yes'">
      <div class="form-group">
        <label for="question7a" class="form-check-label col-sm-9">
          7a. How many video/cable complaints did your community receive in
          {{ today | date: "yyyy" }}?
        </label>
        <input
          type="text"
          trim="blur"
          name="question7a"
          class="form-control col-sm-3"
          [formControl]="franchiseForm.controls['question7a']"
          id="question7a"
          [(ngModel)]="franchiseData.question7a"
        />
        <div
          *ngIf="franchiseForm?.controls['question7a']?.errors?.numeric"
          class="error-msg col-sm-offset-9"
        >
          Please enter a valid number!
        </div>
        <div
          *ngIf="
            franchiseData.question7 == 'Yes' &&
            !franchiseData.question7a &&
            franchiseForm?.controls['question7a']?.touched
          "
          class="error-msg col-sm-offset-9"
        >
          This field is Required!
        </div>
      </div>

      <div class="form-group ml-4">
        <fieldset id="question7bGroup">
          <legend class="form-check-label legend-hidden">.</legend>
          <label id="question7bLabel" class="form-check-label">
            7b. Does your community attempt to resolve those complaints?
          </label>
          <div *ngFor="let option of yesNoOptions; let i = index" class="ml-3">
            <label for="question7b{{ i }}">
              <input
                type="radio"
                id="question7b{{ i }}"
                name="question7bGroup"
                [(ngModel)]="franchiseData.question7b"
                [value]="option.value"
              />
              {{ option.display }}
            </label>
          </div>
          <div
            *ngIf="
              franchiseData.question7 == 'Yes' &&
              franchiseData.question7b == null &&
              franchiseForm?.controls['question7b']?.touched
            "
            class="error-msg ml-3"
          >
            This field is Required!
          </div>
        </fieldset>
      </div>

      <div class="form-group">
        <label for="question7c" trim="blur" class="form-check-label col-sm-9"
          >7c. How many of the above video/cable complaints did you forward to
          the MPSC?
        </label>
        <input
          type="text"
          name="question7c"
          class="form-control col-sm-3"
          id="question7c"
          [formControl]="franchiseForm.controls['question7c']"
          [(ngModel)]="franchiseData.question7c"
        />
        <div
          *ngIf="
            franchiseForm?.controls['question7c']?.errors?.numeric &&
            franchiseForm?.controls['question7c']?.touched
          "
          class="error-msg col-sm-offset-9"
        >
          Please enter a valid number!
        </div>
        <div
          *ngIf="
            franchiseData.question7 == 'Yes' &&
            !franchiseData.question7c &&
            franchiseForm?.controls['question7c']?.touched
          "
          class="error-msg col-sm-offset-9"
        >
          This field is Required!
        </div>
      </div>
      <label for="question7d" class="form-check-label ml-4">
        7d. What were some of the most frequent video/cable complaints received?
        (Check all that apply)
      </label>
      <div class="form-check ml-5">
        <input
          type="hidden"
          name="Question7dRates"
          [(ngModel)]="franchiseData.Question7dRates"
        />
        <label>
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="franchiseData.Question7dRates === yesNoOptions[0].value"
            (change)="
              $event.target.checked
                ? (franchiseData.Question7dRates = yesNoOptions[0].value)
                : (franchiseData.Question7dRates = yesNoOptions[1].value)
            "
          />
          Rates
        </label>
      </div>
      <div class="form-check ml-5">
        <input
          type="hidden"
          name="question7dCustomer"
          [(ngModel)]="franchiseData.question7dCustomer"
        />
        <label>
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="
              franchiseData.question7dCustomer === yesNoOptions[0].value
            "
            (change)="
              $event.target.checked
                ? (franchiseData.question7dCustomer = yesNoOptions[0].value)
                : (franchiseData.question7dCustomer = yesNoOptions[1].value)
            "
          />
          Customer Service
        </label>
      </div>
      <div class="form-check ml-5">
        <input
          type="hidden"
          name="question7dBilling"
          [(ngModel)]="franchiseData.question7dBilling"
        />
        <label>
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="
              franchiseData.question7dBilling === yesNoOptions[0].value
            "
            (change)="
              $event.target.checked
                ? (franchiseData.question7dBilling = yesNoOptions[0].value)
                : (franchiseData.question7dBilling = yesNoOptions[1].value)
            "
          />
          Billing Issues
        </label>
      </div>
      <div class="form-check ml-5">
        <input
          type="hidden"
          name="question7dService"
          [(ngModel)]="franchiseData.question7dService"
        />
        <label>
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="
              franchiseData.question7dService === yesNoOptions[0].value
            "
            (change)="
              $event.target.checked
                ? (franchiseData.question7dService = yesNoOptions[0].value)
                : (franchiseData.question7dService = yesNoOptions[1].value)
            "
          />
          Service/Equipment Problems and Outages
        </label>
      </div>
      <div class="form-check ml-5">
        <input
          type="hidden"
          name="question7dOther"
          [(ngModel)]="franchiseData.question7dOther"
        />
        <label>
          <input
            type="checkbox"
            class="form-check-input"
            [checked]="franchiseData.question7dOther === yesNoOptions[0].value"
            (change)="
              $event.target.checked
                ? (franchiseData.question7dOther = yesNoOptions[0].value)
                : (franchiseData.question7dOther = yesNoOptions[1].value)
            "
          />
          Other
        </label>
      </div>
      <div class="form-group col-sm-11 ml-5">
        <textarea
          class="form-control"
          [disabled]="franchiseData.question7dOther !== 'Yes'"
          name="question7dComment"
          aria-label="question7dComment"
          [(ngModel)]="franchiseData.question7dComment"
          id="question7dComment"
        >
        </textarea>
      </div>
      <div
        *ngIf="
          franchiseData.question7 == 'Yes' &&
          franchiseData.Question7dRates == 'No' &&
          franchiseData.question7dCustomer == 'No' &&
          franchiseData.question7dBilling == 'No' &&
          franchiseData.question7dService == 'No' &&
          franchiseData.question7dOther == 'No' &&
          (franchiseForm?.controls['Question7dRates']?.touched ||
            franchiseForm?.controls['question7dCustomer']?.touched ||
            franchiseForm?.controls['question7dBilling']?.touched ||
            franchiseForm?.controls['question7dService']?.touched ||
            franchiseForm?.controls['question7dOther']?.touched)
        "
        class="error-msg ml-3 col-sm-12"
      >
        This field is Required!
      </div>
    </div>
  </div>

  <div class="form-group col-sm-12">
    <fieldset id="question8Group">
      <legend class="form-check-label legend-hidden">8.</legend>
      <label id="question8Label" class="form-check-label required">
        8. Are you aware that the MPSC can assist customers, franchise entities,
        and providers who have video/cable questions and/or problems?
      </label>
      <div class="form-check ml-3">
        <input
          type="radio"
          class="form-check-input"
          [formControl]="franchiseForm.controls['question8']"
          name="question8Group"
          [(ngModel)]="franchiseData.question8"
          id="question8Yes"
          value="Yes"
        />
        <label for="question8Yes"> Yes </label>
      </div>

      <div class="form-check ml-3">
        <input
          type="radio"
          [formControl]="franchiseForm.controls['question8']"
          class="form-check-input"
          name="question8Group"
          id="question8No"
          [(ngModel)]="franchiseData.question8"
          value="No"
        />
        <label for="question8No">
          No - If no, here is a link to the MPSC Video/Cable website where you
          will find a consumer tip regarding
          <a
            href="https://www.michigan.gov/-/media/Project/Websites/mpsc/consumer/info/tips/telecom/Video_Cable_Complaints.pdf"
          >
            <strong> Filing a Video/Cable Complaint</strong>
          </a>
        </label>
      </div>
      <div
        *ngIf="
          franchiseForm?.controls['question8']?.errors?.required &&
          franchiseForm?.controls['question8']?.touched
        "
        class="error-msg ml-3"
      >
        This field is Required!
      </div>
    </fieldset>
  </div>
  <div class="form-group col-sm-12">
    <fieldset id="question9Group">
      <legend class="form-check-label legend-hidden">9.</legend>
      <label id="question9Label" class="form-check-label required">
        9. Do you provide your citizens with a link on your community's website
        to the MPSC's video/cable page?
      </label>
      <div class="form-check ml-3">
        <input
          type="radio"
          class="form-check-input"
          [formControl]="franchiseForm.controls['question9']"
          name="question9Group"
          [(ngModel)]="franchiseData.question9"
          id="question9Yes"
          value="Yes"
        />
        <label for="question9Yes"> Yes </label>
      </div>

      <div class="form-check ml-3">
        <input
          type="radio"
          class="form-check-input"
          [formControl]="franchiseForm.controls['question9']"
          name="question9Group"
          id="question9No"
          [(ngModel)]="franchiseData.question9"
          value="No"
        />
        <label for="question9No">
          No - If no, here is a link to
          <a
            href="https://www.michigan.gov/mpsc/consumer/telecommunications/video"
            ><strong>MPSC Video/Cable Consumer Information</strong></a
          >. We encourage you to share this information with your residents.
        </label>
      </div>
      <div
        *ngIf="
          franchiseForm?.controls['question9']?.errors?.required &&
          franchiseForm?.controls['question9']?.touched
        "
        class="error-msg ml-3"
      >
        This field is Required!
      </div>
    </fieldset>
  </div>
  <div class="form-group col-sm-12">
    <fieldset id="question10Group">
      <legend class="form-check-label legend-hidden">10.</legend>
      <label id="question10Label" class="form-check-label required">
        10. During {{ today | date: "yyyy" }}, have there been any informal or formal disputes
        regarding your Uniform Video Service Local Franchise Agreements?
      </label>
      <div *ngFor="let option of yesNoOptions; let i = index" class="ml-3">
        <label for="question10{{ i }}">
          <input
            type="radio"
            id="question10{{ i }}"
            (change)="disabledQ10Fields()"
            [formControl]="franchiseForm.controls['question10']"
            name="question10Group"
            [(ngModel)]="franchiseData.question10"
            [value]="option.value"
          />
          {{ option.display }}
        </label>
      </div>
      <div
        *ngIf="
          franchiseForm?.controls['question10']?.errors?.required &&
          franchiseForm?.controls['question10']?.touched
        "
        class="error-msg ml-3"
      >
        This field is Required!
      </div>
    </fieldset>
    <strong class="ml-4">
      If you checked
      <u>yes</u>, what was the dispute regarding? (Check all that apply)
    </strong>
    <div class="form-check ml-5">
      <input
        type="hidden"
        name="question10Franchise"
        [(ngModel)]="franchiseData.question10Franchise"
      />
      <label>
        <input
          type="checkbox"
          [disabled]="franchiseData.question10 != 'Yes'"
          class="form-check-input"
          [checked]="
            franchiseData.question10Franchise === yesNoOptions[0].value
          "
          (change)="
            $event.target.checked
              ? (franchiseData.question10Franchise = yesNoOptions[0].value)
              : (franchiseData.question10Franchise = yesNoOptions[1].value)
          "
        />
        Franchise Fee
      </label>
    </div>
    <div class="form-check ml-5">
      <input
        type="hidden"
        name="question10Agreement"
        [(ngModel)]="franchiseData.question10Agreement"
      />
      <label>
        <input
          type="checkbox"
          [disabled]="franchiseData.question10 != 'Yes'"
          class="form-check-input"
          [checked]="
            franchiseData.question10Agreement === yesNoOptions[0].value
          "
          (change)="
            $event.target.checked
              ? (franchiseData.question10Agreement = yesNoOptions[0].value)
              : (franchiseData.question10Agreement = yesNoOptions[1].value)
          "
        />
        Agreement Language
      </label>
    </div>
    <div class="form-check ml-5">
      <input
        type="hidden"
        name="question10Peg"
        [(ngModel)]="franchiseData.question10Peg"
      />
      <label>
        <input
          type="checkbox"
          [disabled]="franchiseData.question10 != 'Yes'"
          class="form-check-input"
          [checked]="franchiseData.question10Peg === yesNoOptions[0].value"
          (change)="
            $event.target.checked
              ? (franchiseData.question10Peg = yesNoOptions[0].value)
              : (franchiseData.question10Peg = yesNoOptions[1].value)
          "
        />
        PEG Fee
      </label>
    </div>
    <div class="form-check ml-5">
      <input
        type="hidden"
        name="question10Filling"
        [(ngModel)]="franchiseData.question10Filling"
      />
      <label>
        <input
          type="checkbox"
          [disabled]="franchiseData.question10 != 'Yes'"
          class="form-check-input"
          [checked]="franchiseData.question10Filling === yesNoOptions[0].value"
          (change)="
            $event.target.checked
              ? (franchiseData.question10Filling = yesNoOptions[0].value)
              : (franchiseData.question10Filling = yesNoOptions[1].value)
          "
        />
        Filing Dates
      </label>
    </div>
    <div class="form-check ml-5">
      <input
        type="hidden"
        name="question10Other"
        [(ngModel)]="franchiseData.question10Other"
      />
      <label>
        <input
          type="checkbox"
          [disabled]="franchiseData.question10 != 'Yes'"
          class="form-check-input"
          [checked]="franchiseData.question10Other === yesNoOptions[0].value"
          (change)="checkQuestion10($event.target.checked)"
        />
        Other
      </label>
    </div>
    <div class="form-group col-sm-12 ml-4">
      <textarea
        class="form-control col-sm-12"
        [disabled]="franchiseData.question10Other !== 'Yes'"
        trim="blur"
        name="question10Comment"
        aria-label="question10Comment"
        [(ngModel)]="franchiseData.question10Comment"
        id="question10Comment"
      >
      </textarea>
      <div
        *ngIf="
          franchiseData.question10Other === 'Yes' &&
          (franchiseData.question10Comment === '' ||
            franchiseData.question10Comment === 'undefined' ||
            franchiseData.question10Comment === null)
        "
        class="error-msg ml-3"
      >
        This field is Required when other is checked!
      </div>
    </div>
    <div
      *ngIf="
        franchiseData.question10 === 'Yes' &&
        (franchiseData.question10Franchise === 'No' ||
          !franchiseData.question10Franchise) &&
        (franchiseData.question10Agreement === 'No' ||
          !franchiseData.question10Agreement) &&
        (franchiseData.question10Peg === 'No' ||
          !franchiseData.question10Peg) &&
        (franchiseData.question10Other === 'No' ||
          !franchiseData.question10Other) &&
        (franchiseData.question10Filling === 'No' ||
          !franchiseData.question10Filling) &&
        (franchiseForm?.controls['question10Franchise']?.touched ||
          franchiseForm?.controls['question10Agreement']?.touched ||
          franchiseForm?.controls['question10Other']?.touched ||
          franchiseForm?.controls['question10Peg']?.touched ||
          franchiseForm?.controls['question10Filling']?.touched)
      "
      class="error-msg ml-3"
    >
      At least one option should be selected if you checked Yes!
    </div>
  </div>

  <div class="form-group col-sm-12">
    <fieldset id="question11Group">
      <legend class="form-check-label legend-hidden">11.</legend>
      <label id="question11Label" class="form-check-label required">
        11. Did your franchise entity contact the MPSC regarding the dispute?
      </label>
      <div *ngFor="let option of yesNoOptions; let i = index" class="ml-3">
        <label for="question11{{ i }}">
          <input
            type="radio"
            id="question11{{ i }}"
            [formControl]="franchiseForm.controls['question11']"
            name="question11Group"
            [(ngModel)]="franchiseData.question11"
            [value]="option.value"
          />
          {{ option.display }}
        </label>
      </div>
      <div
        *ngIf="
          franchiseForm?.controls['question11']?.errors?.required &&
          franchiseForm?.controls['question11']?.touched
        "
        class="error-msg ml-3"
      >
        This field is Required!
      </div>
    </fieldset>
  </div>

  <div class="form-group col-sm-12">
    <label id="question12Label" class="form-check-label required">
      12. Since PA 480 has become effective, what has been the impact (if any)
      on your community?
    </label>

    <table class="table table-sm ml-3" role="presentation">
      <tbody>
        <tr class="col-md-12">
          <fieldset id="question12Video">
            <legend class="form-check-label legend-hidden col-md-12">
              12.Video
            </legend>
            <td class="col-md-4">Video/Cable Competition</td>
            <td class="col-md-4">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="
                    franchiseForm.controls['question12Competition']
                  "
                  name="question12Video"
                  aria-label="pa-480-competition-0"
                  [(ngModel)]="franchiseData.question12Competition"
                  id="pa-480-competition-0"
                  value="0"
                />
                <label for="pa-480-competition-0">Increase</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="
                    franchiseForm.controls['question12Competition']
                  "
                  aria-label="pa-480-competition-1"
                  name="question12Video"
                  id="pa-480-competition-1"
                  [(ngModel)]="franchiseData.question12Competition"
                  value="1"
                />
                <label for="pa-480-competition-1">Decrease</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="
                    franchiseForm.controls['question12Competition']
                  "
                  aria-label="pa-480-competition-2"
                  name="question12Video"
                  id="pa-480-competition-2"
                  [(ngModel)]="franchiseData.question12Competition"
                  value="2"
                />
                <label for="pa-480-competition-2">None</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question12Competition']"
                  aria-label="pa-480-competition-3"
                  name="question12Video"
                  id="pa-480-competition-3"
                  [(ngModel)]="franchiseData.question12Competition"
                  value="3"
                />
                <label for="pa-480-competition-3">Unsure</label>
              </div>
            </td>
            <td
              class="col-md-3 error-msg"
              *ngIf="
                franchiseForm?.controls['question12Competition']?.errors
                  ?.required &&
                franchiseForm?.controls['question12Competition']?.touched
              "
            >
              This field is Required!
            </td>
          </fieldset>
        </tr>
        <tr class="col-md-12">
          <fieldset id="question12Franchise">
            <legend class="form-check-label legend-hidden">12.Franchise</legend>
            <td class="col-md-4">Franchise Fee Payments</td>
            <td class="col-md-4">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question12Franchise']"
                  aria-label="pa-480-franchise-0"
                  name="question12Franchise"
                  id="pa-480-franchise-0"
                  [(ngModel)]="franchiseData.question12Franchise"
                  value="0"
                />
                <label for="pa-480-franchise-0">Increase</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question12Franchise']"
                  aria-label="pa-480-franchise-1"
                  name="question12Franchise"
                  id="pa-480-franchise-1"
                  [(ngModel)]="franchiseData.question12Franchise"
                  value="1"
                />
                <label for="pa-480-franchise-1">Decrease</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question12Franchise']"
                  aria-label="pa-480-franchise-2"
                  name="question12Franchise"
                  id="pa-480-franchise-2"
                  [(ngModel)]="franchiseData.question12Franchise"
                  value="2"
                />
                <label for="pa-480-franchise-2">None</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question12Franchise']"
                  aria-label="pa-480-franchise-3"
                  name="question12Franchise"
                  id="pa-480-franchise-3"
                  [(ngModel)]="franchiseData.question12Franchise"
                  value="3"
                />
                <label for="pa-480-franchise-3">Unsure</label>
              </div>
            </td>
            <td
              class="col-md-3 error-msg"
              *ngIf="
                franchiseForm?.controls['question12Franchise']?.errors
                  ?.required &&
                franchiseForm?.controls['question12Franchise']?.touched
              "
            >
              This field is Required!
            </td>
          </fieldset>
        </tr>
        <tr class="col-md-12">
          <fieldset id="question12PEG">
            <legend class="form-check-label legend-hidden">12.PEG</legend>
            <td class="col-md-4">PEG Fee payments/support</td>
            <td class="col-md-4">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question12Peg']"
                  aria-label="pa-480-peg-0"
                  name="question12PEG"
                  id="pa-480-peg-0"
                  [(ngModel)]="franchiseData.question12Peg"
                  value="0"
                />
                <label for="pa-480-peg-0">Increase</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question12Peg']"
                  aria-label="pa-480-peg-1"
                  name="question12PEG"
                  id="pa-480-peg-1"
                  [(ngModel)]="franchiseData.question12Peg"
                  value="1"
                />
                <label for="pa-480-peg-1">Decrease</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question12Peg']"
                  aria-label="pa-480-peg-2"
                  name="question12PEG"
                  id="pa-480-peg-2"
                  [(ngModel)]="franchiseData.question12Peg"
                  value="2"
                />
                <label for="pa-480-peg-2">None</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question12Peg']"
                  aria-label="pa-480-peg-3"
                  name="question12PEG"
                  id="pa-480-peg-3"
                  [(ngModel)]="franchiseData.question12Peg"
                  value="3"
                />
                <label for="pa-480-peg-3">Unsure</label>
              </div>
            </td>

            <td
              class="col-md-3 error-msg"
              *ngIf="
                franchiseForm?.controls['question12Peg']?.errors?.required &&
                franchiseForm?.controls['question12Peg']?.touched
              "
            >
              This field is Required!
            </td>
          </fieldset>
        </tr>
        <tr class="col-md-12">
          <fieldset id="question12Complaints">
            <legend class="form-check-label legend-hidden">
              12.Complaints
            </legend>
            <td class="col-md-4">Video/Cable Complaints</td>
            <td class="col-md-4">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question12Complaints']"
                  aria-label="pa-480-complaints-0"
                  name="question12Complaints"
                  id="pa-480-complaints-0"
                  [(ngModel)]="franchiseData.question12Complaints"
                  value="0"
                />
                <label for="pa-480-complaints-0">Increase</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question12Complaints']"
                  aria-label="pa-480-complaints-1"
                  name="question12Complaints"
                  id="pa-480-complaints-1"
                  [(ngModel)]="franchiseData.question12Complaints"
                  value="1"
                />
                <label for="pa-480-complaints-1">Decrease</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question12Complaints']"
                  aria-label="pa-480-complaints-2"
                  name="question12Complaints"
                  id="pa-480-complaints-2"
                  [(ngModel)]="franchiseData.question12Complaints"
                  value="2"
                />
                <label for="pa-480-complaints-2">None</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question12Complaints']"
                  aria-label="pa-480-complaints-3"
                  name="question12Complaints"
                  id="pa-480-complaints-3"
                  [(ngModel)]="franchiseData.question12Complaints"
                  value="3"
                />
                <label for="pa-480-complaints-3">Unsure</label>
              </div>
            </td>
            <td
              class="col-md-3 error-msg"
              *ngIf="
                franchiseForm?.controls['question12Complaints']?.errors
                  ?.required &&
                franchiseForm?.controls['question12Complaints']?.touched
              "
            >
              This field is Required!
            </td>
          </fieldset>
        </tr>
        <tr class="col-md-12">
          <td class="col-md-4">Other</td>
        </tr>
        <tr>
          <div class="form-group col-sm-12">
            <textarea
              class="form-control"
              trim="blur"
              name="question12Comment"
              aria-label="question12Comment"
              [(ngModel)]="franchiseData.question12Comment"
              id="question12Comment"
            >
            </textarea>
          </div>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="form-group col-sm-12">
    <label id="question13Label" class="form-check-label required">
      13. Has the quality of service and/or service offerings of the providers
      changed in your community since PA 480 became effective?
    </label>

    <table class="table table-sm ml-3" role="presentation">
      <tbody>
        <tr class="col-md-12">
          <fieldset id="question13Quality">
            <legend class="form-check-label legend-hidden">13. Quality</legend>
            <td class="col-md-4">Customer Service Quality</td>
            <td class="col-md-4">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question13Customer']"
                  aria-label="quality-customer-service-0"
                  name="question13Quality"
                  id="quality-customer-service-0"
                  [(ngModel)]="franchiseData.question13Customer"
                  value="0"
                />
                <label for="quality-customer-service-0">Increase</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question13Customer']"
                  aria-label="quality-customer-service-1"
                  name="question13Quality"
                  id="quality-customer-service-1"
                  [(ngModel)]="franchiseData.question13Customer"
                  value="1"
                />
                <label for="quality-customer-service-1">Decrease</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question13Customer']"
                  aria-label="quality-customer-service-2"
                  name="question13Quality"
                  id="quality-customer-service-2"
                  [(ngModel)]="franchiseData.question13Customer"
                  value="2"
                />
                <label for="quality-customer-service-2">None</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question13Customer']"
                  aria-label="quality-customer-service-3"
                  name="question13Customer"
                  id="quality-customer-service-3"
                  [(ngModel)]="franchiseData.question13Customer"
                  value="3"
                />
                <label for="quality-customer-service-3">Unsure</label>
              </div>
            </td>
            <td
              class="col-md-3 error-msg"
              *ngIf="
                franchiseForm?.controls['question13Customer']?.errors
                  ?.required &&
                franchiseForm?.controls['question13Customer']?.touched
              "
            >
              This field is Required!
            </td>
          </fieldset>
        </tr>
        <tr class="col-md-12">
          <fieldset id="question13Peg">
            <legend class="form-check-label legend-hidden">13. PEG</legend>
            <td class="col-md-4">PEG Studios and Equipment</td>
            <td class="col-md-4">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question13Peg']"
                  aria-label="quality-peg-0"
                  name="question13Peg"
                  id="quality-peg-0"
                  [(ngModel)]="franchiseData.question13Peg"
                  value="0"
                />
                <label for="quality-peg-0">Increase</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question13Peg']"
                  aria-label="quality-peg-1"
                  name="question13Peg"
                  id="quality-peg-1"
                  [(ngModel)]="franchiseData.question13Peg"
                  value="1"
                />
                <label for="quality-peg-1">Decrease</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question13Peg']"
                  aria-label="quality-peg-2"
                  name="question13Peg"
                  id="quality-peg-2"
                  [(ngModel)]="franchiseData.question13Peg"
                  value="2"
                />
                <label for="quality-peg-2">None</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question13Peg']"
                  aria-label="quality-peg-3"
                  name="question13Peg"
                  id="quality-peg-3"
                  [(ngModel)]="franchiseData.question13Peg"
                  value="3"
                />
                <label for="quality-peg-3">Unsure</label>
              </div>
            </td>
            <td
              class="col-md-3 error-msg"
              *ngIf="
                franchiseForm?.controls['question13Peg']?.errors?.required &&
                franchiseForm?.controls['question13Peg']?.touched
              "
            >
              This field is Required!
            </td>
          </fieldset>
        </tr>
        <tr class="col-md-12">
          <fieldset id="question13Services">
            <legend class="form-check-label legend-hidden">13. Services</legend>
            <td class="col-md-4">Services Offered by Provider</td>
            <td class="col-md-4">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question13Services']"
                  aria-label="quality-services-0"
                  name="question13Services"
                  id="quality-services-0"
                  [(ngModel)]="franchiseData.question13Services"
                  value="0"
                />
                <label for="quality-services-0">Increase</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question13Services']"
                  aria-label="quality-services-1"
                  name="question13Services"
                  id="quality-services-1"
                  [(ngModel)]="franchiseData.question13Services"
                  value="1"
                />
                <label for="quality-services-1">Decrease</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question13Services']"
                  aria-label="quality-services-2"
                  name="question13Services"
                  id="quality-services-2"
                  [(ngModel)]="franchiseData.question13Services"
                  value="2"
                />
                <label for="quality-services-2">None</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question13Services']"
                  aria-label="quality-services-3"
                  name="question13Services"
                  id="quality-services-3"
                  [(ngModel)]="franchiseData.question13Services"
                  value="3"
                />
                <label for="quality-services-3">Unsure</label>
              </div>
            </td>
            <td
              class="col-md-3 error-msg"
              *ngIf="
                franchiseForm?.controls['question13Services']?.errors
                  ?.required &&
                franchiseForm?.controls['question13Services']?.touched
              "
            >
              This field is Required!
            </td>
          </fieldset>
        </tr>
        <tr class="col-md-12">
          <fieldset id="question13ServiceCenters">
            <legend class="form-check-label legend-hidden">
              13. Services Centers
            </legend>
            <td class="col-md-4">Number of Customer Service Centers</td>
            <td class="col-md-4">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="
                    franchiseForm.controls['question13ServiceCenter']
                  "
                  aria-label="quality-centers-0"
                  name="question13ServiceCenters"
                  id="quality-centers-0"
                  [(ngModel)]="franchiseData.question13ServiceCenter"
                  value="0"
                />
                <label for="quality-centers-0">Increase</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="
                    franchiseForm.controls['question13ServiceCenter']
                  "
                  aria-label="quality-centers-1"
                  name="question13ServiceCenters"
                  id="quality-centers-1"
                  [(ngModel)]="franchiseData.question13ServiceCenter"
                  value="1"
                />
                <label for="quality-centers-1">Decrease</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="
                    franchiseForm.controls['question13ServiceCenter']
                  "
                  aria-label="quality-centers-2"
                  name="question13ServiceCenters"
                  id="quality-centers-2"
                  [(ngModel)]="franchiseData.question13ServiceCenter"
                  value="2"
                />
                <label for="quality-centers-2">None</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  [formControl]="franchiseForm.controls['question13ServiceCenter']"
                  aria-label="quality-centers-3"
                  name="question13ServiceCenters"
                  id="quality-centers-3"
                  [(ngModel)]="franchiseData.question13ServiceCenter"
                  value="3"
                />
                <label for="quality-centers-3">Unsure</label>
              </div>
            </td>
            <td
              class="col-md-3 error-msg"
              *ngIf="
                franchiseForm?.controls['question13ServiceCenter']?.errors
                  ?.required &&
                franchiseForm?.controls['question13ServiceCenter']?.touched
              "
            >
              This field is Required!
            </td>
          </fieldset>
        </tr>
        <tr class="col-md-12">
          <td class="col-md-4">Other</td>
        </tr>
        <tr>
          <div class="form-group col-sm-12">
            <textarea
              class="form-control"
              trim="blur"
              name="question13Comment"
              aria-label="question13Comment"
              [(ngModel)]="franchiseData.question13Comment"
              id="question13Comment"
            >
            </textarea>
          </div>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="form-group col-sm-12">
    <fieldset id="question14Group">
      <legend class="form-check-label legend-hidden">14.</legend>
      <label id="question14Label" class="form-check-label required">
        14. Does your community have designated Public, Education, and
        Government (PEG) channels?
      </label>
      <div *ngFor="let option of yesNoOptions; let i = index" class="ml-3">
        <label for="question14{{ i }}">
          <input
            type="radio"
            id="question14{{ i }}"
            [formControl]="franchiseForm.controls['question14']"
            name="question14Label"
            [(ngModel)]="franchiseData.question14"
            [value]="option.value"
          />
          {{ option.display }}
        </label>
      </div>
      <div
        *ngIf="
          franchiseForm?.controls['question14']?.errors?.required &&
          franchiseForm?.controls['question14']?.touched
        "
        class="error-msg ml-3"
      >
        This field is Required!
      </div>
    </fieldset>
  </div>

  <div class="form-group col-sm-12">
    <fieldset id="question15Group">
      <legend class="form-check-label legend-hidden">15.</legend>
      <label id="question15Label" class="form-check-label required">
        15. Have you completed this survey prior to {{ today | date: "yyyy" }}?
      </label>
      <div *ngFor="let option of surveyOptions; let i = index" class="ml-3">
        <label for="question15{{ i }}">
          <input
            type="radio"
            id="question15{{ i }}"
            [formControl]="franchiseForm.controls['question15']"
            name="question15Group"
            [(ngModel)]="franchiseData.question15"
            [value]="option.value"
          />
          {{ option.display }}
        </label>
      </div>
      <div
        *ngIf="
          franchiseForm?.controls['question15']?.errors?.required &&
          franchiseForm?.controls['question15']?.touched
        "
        class="error-msg ml-3"
      >
        This field is Required!
      </div>
    </fieldset>
  </div>

  <div class="form-group col-sm-12">
    <label for="question16" class="form-check-label">
      16. The MPSC has a series of Consumer Tips informing customers on issues
      relating to cable, telecommunications, natural gas and electric services.
      To receive these notifications please provide your email address.
    </label>
    <div class="form-group col-sm-12 ml-2">
      <input
        type="emailId"
        class="form-control"
        id="question16"
        [(ngModel)]="franchiseData.question16"
        placeholder="Enter Email Address"
        name="question16"
        [formControl]="franchiseForm.controls['question16']"
      />
      <div
        *ngIf="
          franchiseData.question16 !== 'undefined' &&
          franchiseData.question16 != null &&
          franchiseData.question16 != '' &&
          franchiseForm?.controls['question16']?.errors?.email &&
          franchiseForm?.controls['question16']?.touched
        "
        class="error-msg ml-3"
      >
        Please enter a valid email address!
      </div>
    </div>
  </div>

  <!--Question 17 removed from https://devops.lara.state.mi.us/LARA/Tracker/_workitems/edit/223540. Having 18 show as 17 while keeping the columns same for the ordering-->
  <div class="form-group col-sm-12">
    <label for="question18" class="form-check-label"
      >17. Please provide any other comments or suggestions</label
    >
    <div class="form-group col-sm-12 ml-2">
      <textarea
        class="form-control"
        trim="blur"
        [maxLength]="500"
        name="question18"
        [(ngModel)]="franchiseData.question18"
        id="question18"
      >
      </textarea>
    </div>
    <small> (Maximum characters : 500)</small>
  </div>

  <div class="form-group col-sm-12">
    <p>
      Please review the form before clicking submit.
      <strong>
        <u>All fields are required.</u>
      </strong>
      Please press submit only once. By submitting, you are certifying that the
      foregoing responses are true and correct to the best of your knowledge,
      information, and belief. Once you have submitted your survey, you will
      receive a confirmation receipt that may be printed for your records. If
      this confirmation does not appear, check the required fields, as there may
      be an error.
    </p>
  </div>

  <div class="form-group col-sm-12 text-center">
    <!-- <button type="button" (click)="Menu()" class="btn btn-dark">Back To Menu</button> -->
    <button type="submit" (click)="save()" class="btn btn-primary offset1">
      Submit
    </button>
  </div>
</div>

<div class="container" *ngIf="completionPage">
  <div class="col-sm-12">
    <strong class="col-sm-12 text-center"
      >Here is the information you have submitted.</strong
    >
    <strong class="col-sm-12 text-center"
      >Please print a copy for your records.</strong
    >
  </div>

  <div class="col-sm-12 mt-5">
    <table
      class="table table-striped table-bordered col-sm-12"
      role="presentation"
    >
      <tbody>
        <tr>
          <th class="col-sm-4"></th>
          <th class="col-sm-8"></th>
        </tr>
        <tr>
          <td>Franchise Entity:</td>
          <td>{{ franchiseData.franchiseEntity }}</td>
        </tr>
        <tr>
          <td>Address:</td>
          <td>{{ franchiseData.address1 }}</td>
        </tr>
        <tr>
          <td>Address 2:</td>
          <td>{{ franchiseData.address2 }}</td>
        </tr>
        <tr>
          <td>City:</td>
          <td>{{ franchiseData.city }}</td>
        </tr>
        <tr>
          <td>County:</td>
          <td>{{ franchiseData.county }}</td>
        </tr>
        <tr>
          <td>State:</td>
          <td>{{ franchiseData.state }}</td>
        </tr>
        <tr>
          <td>Zip:</td>
          <td>{{ franchiseData.zip }}</td>
        </tr>
        <tr>
          <td>Contact Person:</td>
          <td>{{ franchiseData.contactPerson }}</td>
        </tr>
        <tr>
          <td>Phone:</td>
          <td>{{ franchiseData.phoneNumber }}</td>
        </tr>
        <tr>
          <td>Contact Email:</td>
          <td>{{ franchiseData.emailId }}</td>
        </tr>
        <tr>
          <td>Total Agreements:</td>
          <td>{{ franchiseData.question1 }}</td>
        </tr>
        <tr>
          <td>Current Provider:</td>
          <td>
            {{ franchiseData.question2Comcast == "Yes" ? "Comcast " : "" }}
            {{
              franchiseData.question2Charter == "Yes"
                ? "Charter
            Communications "
                : ""
            }}
            {{ franchiseData.question2Att == "Yes" ? "AT/&T U-verse " : "" }}
            {{ franchiseData.question2Other == "Yes" ? "Other" : "" }}
          </td>
        </tr>
        <tr>
          <td>Other:</td>
          <td>{{ franchiseData.question2Comment }}</td>
        </tr>
        <tr>
          <td>Providers since 01/01/{{ today | date: "yyyy" }}:</td>
          <td>{{ franchiseData.question3 }}</td>
        </tr>
        <tr>
          <td>Providers Prior:</td>
          <td>{{ franchiseData.question4 }}</td>
        </tr>
        <tr>
          <td>Satellite Providers in your community:</td>
          <td>
            {{ franchiseData.question5Dish == "Yes" ? "Dish Network " : "" }}
            {{
              franchiseData.question5Direct == "Yes"
                ? "Direct
            TV "
                : ""
            }}
            {{ franchiseData.question5Other == "Yes" ? "Other" : "" }}
          </td>
        </tr>

        <tr>
          <td>Other:</td>
          <td>{{ franchiseData.question5Comment }}</td>
        </tr>
        <tr>
          <td>Aware of Public Act 4?</td>
          <td>{{ franchiseData.question6 }}</td>
        </tr>
        <tr>
          <td>Receive Complaints?:</td>
          <td>{{ franchiseData.question7 }}</td>
        </tr>
        <tr>
          <td>Number of Complaints:</td>
          <td>{{ franchiseData.question7a }}</td>
        </tr>
        <tr>
          <td>Resolve Attempts:</td>
          <td>{{ franchiseData.question7b }}</td>
        </tr>
        <tr>
          <td>Complaints to MPSC:</td>
          <td>{{ franchiseData.question7c }}</td>
        </tr>
        <tr>
          <td>Complaint Type:</td>
          <td>
            {{ franchiseData.question7dRates == "Yes" ? "Rates " : "" }}
            {{
              franchiseData.question7dCustomer == "Yes"
                ? "Customer
              Service "
                : ""
            }}
            {{
              franchiseData.question7dBilling == "Yes" ? "Billing Issues " : ""
            }}
            {{
              franchiseData.question7dService == "Yes" ? "Service/Equip " : ""
            }}
            {{ franchiseData.question7dOther == "Yes" ? "Other" : "" }}
          </td>
        </tr>
        <tr>
          <td>Other:</td>
          <td>{{ franchiseData.question7dComment }}</td>
        </tr>
        <tr>
          <td>Awareness of MPSC:</td>
          <td>{{ franchiseData.question8 }}</td>
        </tr>
        <tr>
          <td>Provide Link to MPSC:</td>
          <td>{{ franchiseData.question9 }}</td>
        </tr>
        <tr>
          <td>Informal Disputes:</td>
          <td>{{ franchiseData.question10 }}</td>
        </tr>
        <tr>
          <td>Dispute Regarding:</td>
          <td>
            {{
              franchiseData.question10Franchise == "Yes"
                ? " Franchise Fee "
                : ""
            }}
            {{
              franchiseData.question10Agreement == "Yes"
                ? " Agreement Language "
                : ""
            }}
            {{ franchiseData.question10Peg == "Yes" ? " PEG Fee " : "" }}
            {{
              franchiseData.question10Filling == "Yes" ? " Filing Dates " : ""
            }}
            {{ franchiseData.question10Other == "Yes" ? "Other" : "" }}
          </td>
        </tr>
        <tr>
          <td>Other Disputes:</td>
          <td>{{ franchiseData.question10Comment }}</td>
        </tr>
        <tr>
          <td>Contact MPSC about Disputes:</td>
          <td>{{ franchiseData.question11 }}</td>
        </tr>
        <tr>
          <td>Impact on Community:</td>
          <td>
            Competition:
            {{
              franchiseData.question12Competition == "0"
                ? "Increase"
                : franchiseData.question12Competition == "1"
                ? "Decrease"
                : franchisedata.question12Competition == "2"
                ? "None"
                : "Unsure"
            }}
            Franchise Fee Payments:
            {{
              franchiseData.question12Franchise == "0"
                ? "Increase"
                : franchiseData.question12Franchise == "1"
                ? "Decrease"
                : franchisedata.question12Franchise == "2"
                ? "None"
                : "Unsure"
            }}
            PEG Fee Payments:
            {{
              franchiseData.question12Peg == "0"
                ? "Increase"
                : franchiseData.question12Peg == "1"
                ? "Decrease"
                : franchisedata.question12Peg == "2"
                ? "None"
                : "Unsure"
            }}
            Complaints:
            {{
              franchiseData.question12Complaints == "0"
                ? "Increase"
                : franchiseData.question12Complaints == "1"
                ? "Decrease"
                : franchisedata.question12Complaints == "2"
                ? "None"
                : "Unsure"
            }}
            Other:
            {{
              franchiseData.question12Other == "0"
                ? "Increase"
                : franchiseData.question12Other == "1"
                ? "Decrease"
                : "None"
            }}
          </td>
        </tr>
        <tr>
          <td>Other:</td>
          <td>{{ franchiseData.question12Comment }}</td>
        </tr>
        <tr>
          <td>Quality of Service:</td>
          <td>
            Customer Service Quality:
            {{
              franchiseData.question13Customer == "0"
                ? "Increase"
                : franchiseData.question13Customer == "1"
                ? "Decrease"
                : franchisedata.question13Customer == "2"
                ? "None"
                : "Unsure"
            }}
            PEG Studios and Equipment:
            {{
              franchiseData.question13Peg == "0"
                ? "Increase"
                : franchiseData.question13Peg == "1"
                ? "Decrease"
                : franchisedata.question13Peg == "2"
                ? "None"
                : "Unsure"
            }}
            Services Offered:
            {{
              franchiseData.question13Services == "0"
                ? "Increase"
                : franchiseData.question13Services == "1"
                ? "Decrease"
                : franchisedata.question13Services == "2"
                ? "None"
                : "Unsure"
            }}
            Number of CSCs:
            {{
              franchiseData.question13ServiceCenter == "0"
                ? "Increase"
                : franchiseData.question13ServiceCenter == "1"
                ? "Decrease"
                : franchisedata.question13ServiceCenter == "2"
                ? "None"
                : "Unsure"
            }}
            Other:
            {{
              franchiseData.question13Other == "0"
                ? "Increase"
                : franchiseData.question13Other == "1"
                ? "Decrease"
                : "None"
            }}
          </td>
        </tr>
        <tr>
          <td>Other:</td>
          <td>{{ franchiseData.question13Comment }}</td>
        </tr>
        <tr>
          <td>PEG Channels:</td>
          <td>{{ franchiseData.question14 }}</td>
        </tr>
        <tr>
          <td>Complete survey before 2018?:</td>
          <td>{{ franchiseData.question15 }}</td>
        </tr>
        <tr>
          <td>E-mail Notifications?:</td>
          <td>{{ franchiseData.question16 }}</td>
        </tr>
        <tr>
          <td>Recommendations:</td>
          <td>{{ franchiseData.question18 }}</td>
        </tr>
        <tr>
          <td>Date Submitted:</td>
          <td>{{ today | date: "MM/dd/yyyy" }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="form-group col-sm-12 text-center">
    <!-- <button type="button" (click)="Menu()" class="btn btn-dark">Back To Menu</button> -->
    <button type="goBack" (click)="goBack()" class="btn btn-primary offset1">
      Back to Video Franchise Survey
    </button>
  </div>
</div>
